import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if @items}}\n  {{#each @items as |item|}}\n    {{yield item}}\n  {{/each}}\n{{else}}\n  {{yield}}\n{{/if}}\n<div class=\"infinite-list--terminus {{this.terminusUniqueIdentifier}}\"></div>", {
  moduleName: "@dashboard/shared-ui/components/infinite-list.hbs"
});